<template>
  <div
    class="tm-overlay"
    :class="{
      'tm-overlay--active': active,
      'tm-overlay--desktop': !isMobileMenu,
    }"
  />
</template>

<script setup lang="ts">
import { useMenuState } from '@/composition/menuState'

defineProps<{
  active?: boolean
}>()

const { isMobileMenu } = useMenuState()
</script>

<style lang="scss" scoped>
.tm-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  background: rgba(20, 20, 43, 0.6);
  left: -100%;
  opacity: 0;
  transition: opacity $transition-300ms-ease-in-out;
  visibility: hidden;

  &--desktop {
    z-index: 21;
  }

  &--active {
    opacity: 1;
    visibility: visible;
    left: 0;
  }
}
</style>
